export default import.meta.ROLLDOWN_FILE_URL_V6UYC1_EFfGnYGLE7Hx52g